import { useSelector } from "react-redux";
import { getExplorer } from "../utils/explorer";

/**
 * The block explorer chosen in the settings
 */
export const useExplorer = () => getExplorer(useSelector((state) => state.settings.explorer));
